const ansiStyles = {
  '.ansi-black-fg': {
    color: '#3e424d',
  },
  '.ansi-red-fg': {
    color: '#e75c58',
  },
  '.ansi-green-fg': {
    color: '#00a250',
  },
  '.ansi-yellow-fg': {
    color: '#ddb62b',
  },
  '.ansi-blue-fg': {
    color: '#208ffb',
  },
  '.ansi-magenta-fg': {
    color: '#d160c4',
  },
  '.ansi-cyan-fg': {
    color: '#60c6c8',
  },
  '.ansi-white-fg': {
    color: '#c5c1b4',
  },

  '.ansi-black-bg': {
    backgroundColor: '#3e424d',
    padding: '2px 0',
  },
  '.ansi-red-bg': {
    backgroundColor: '#e75c58',
    padding: '2px 0',
  },
  '.ansi-green-bg': {
    backgroundColor: '#00a250',
    padding: '2px 0',
  },
  '.ansi-yellow-bg': {
    backgroundColor: '#ddb62b',
    padding: '2px 0',
  },
  '.ansi-blue-bg': {
    backgroundColor: '#208ffb',
    padding: '2px 0',
  },
  '.ansi-magenta-bg': {
    backgroundColor: '#d160c4',
    padding: '2px 0',
  },
  '.ansi-cyan-bg': {
    backgroundColor: '#60c6c8',
    padding: '2px 0',
  },
  '.ansi-white-bg': {
    backgroundColor: '#c5c1b4',
    padding: '2px 0',
  },

  '.ansi-black-intense-fg': {
    color: '#282c36',
  },
  '.ansi-red-intense-fg': {
    color: '#b22b31',
  },
  '.ansi-green-intense-fg': {
    color: '#007427',
  },
  '.ansi-yellow-intense-fg': {
    color: '#b27d12',
  },
  '.ansi-blue-intense-fg': {
    color: '#0065ca',
  },
  '.ansi-magenta-intense-fg': {
    color: '#a03196',
  },
  '.ansi-cyan-intense-fg': {
    color: '#258f8f',
  },
  '.ansi-white-intense-fg': {
    color: '#a1a6b2',
  },

  '.ansi-black-intense-bg': {
    backgroundColor: '#282c36',
    padding: '2px 0',
  },
  '.ansi-red-intense-bg': {
    backgroundColor: '#b22b31',
    padding: '2px 0',
  },
  '.ansi-green-intense-bg': {
    backgroundColor: '#007427',
    padding: '2px 0',
  },
  '.ansi-yellow-intense-bg': {
    backgroundColor: '#b27d12',
    padding: '2px 0',
  },
  '.ansi-blue-intense-bg': {
    backgroundColor: '#0065ca',
    padding: '2px 0',
  },
  '.ansi-magenta-intense-bg': {
    backgroundColor: '#a03196',
    padding: '2px 0',
  },
  '.ansi-cyan-intense-bg': {
    backgroundColor: '#258f8f',
    padding: '2px 0',
  },
  '.ansi-white-intense-bg': {
    backgroundColor: '#a1a6b2',
    padding: '2px 0',
  },

  '.ansi-default-inverse-fg': {
    color: 'var(--jp-ui-inverse-font-color0)',
  },

  '.ansi-default-inverse-bg': {
    backgroundColor: 'var(--jp-inverse-layout-color0)',
    padding: '2px 0',
  },

  '.ansi-bold': {
    fontWeight: 'bold',
  },
  '.ansi-underline': {
    textDecoration: 'underline',
  },
};

export default ansiStyles;
